var _rect, _path, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnlockedDoorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14.1836,
    width: 16.2026,
    height: 13.8159,
    rx: 1.8125,
    fill: "#202223"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6379 11.0866C15.6379 10.2873 15.7978 9.49585 16.1084 8.75739C16.4191 8.01892 16.8744 7.34793 17.4483 6.78274C18.0223 6.21754 18.7037 5.7692 19.4536 5.46332C20.2035 5.15744 21.0073 5 21.819 5C22.6307 5 23.4344 5.15744 24.1843 5.46332C24.9343 5.7692 25.6157 6.21754 26.1896 6.78274C26.7636 7.34793 27.2189 8.01892 27.5295 8.75739C27.8401 9.49585 28 10.2873 28 11.0866H25.713C25.713 10.5831 25.6123 10.0844 25.4166 9.61921C25.2209 9.15398 24.9341 8.73126 24.5725 8.37518C24.2109 8.01911 23.7816 7.73665 23.3092 7.54395C22.8367 7.35124 22.3303 7.25206 21.819 7.25206C21.3076 7.25206 20.8012 7.35124 20.3288 7.54395C19.8563 7.73665 19.4271 8.01911 19.0655 8.37518C18.7039 8.73126 18.417 9.15398 18.2213 9.61921C18.0256 10.0844 17.9249 10.5831 17.9249 11.0866H15.6379Z",
    fill: "#202223"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.28582,
    height: 3.21559,
    transform: "matrix(-1 0 0 1 17.9229 11.0645)",
    fill: "#202223"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.28582,
    height: 3.21559,
    rx: 1.14291,
    transform: "matrix(-1 0 0 1 28 9.89062)",
    fill: "#202223"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockedDoorIcon);
export default __webpack_public_path__ + "static/media/unlockedDoorIcon.ca90b7702d54c48547577af4ffbe7e7d.svg";
export { ForwardRef as ReactComponent };